var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -7 30 30",
    preserveAspectRatio: "xMinYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36074 10.0822C3.36074 11.032 2.63014 11.7626 1.68037 11.7626C0.730596 11.7626 0 11.032 0 10.0822C0 9.13245 0.730596 8.40186 1.68037 8.40186H3.36074V10.0822Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23877 10.0822C4.23877 9.13245 4.96937 8.40186 5.91914 8.40186C6.86891 8.40186 7.59951 9.13245 7.59951 10.0822V14.3197C7.59951 15.2695 6.86891 16.0001 5.91914 16.0001C4.96937 16.0001 4.23877 15.2695 4.23877 14.3197V10.0822Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91914 3.36074C4.96937 3.36074 4.23877 2.63014 4.23877 1.68037C4.23877 0.730595 4.96937 0 5.91914 0C6.86891 0 7.59951 0.730595 7.59951 1.68037V3.36074H5.91914Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91783 4.16455C6.8676 4.16455 7.59819 4.89515 7.59819 5.84492C7.59819 6.7947 6.8676 7.52529 5.91783 7.52529H1.68037C0.730596 7.52529 0 6.7947 0 5.84492C0 4.89515 0.730596 4.16455 1.68037 4.16455H5.91783Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7168 5.91792C12.7168 4.96815 13.4474 4.23755 14.3972 4.23755C15.3469 4.23755 16.0775 4.96815 16.0775 5.91792C16.0775 6.86769 15.3469 7.59829 14.3972 7.59829H12.7168V5.91792Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8383 5.91783C11.8383 6.8676 11.1077 7.59819 10.1579 7.59819C9.20813 7.59819 8.47754 6.8676 8.47754 5.91783V1.68037C8.47754 0.730595 9.20813 0 10.1579 0C11.1077 0 11.8383 0.730595 11.8383 1.68037V5.91783Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1579 12.6392C11.1077 12.6392 11.8383 13.3698 11.8383 14.3195C11.8383 15.2693 11.1077 15.9999 10.1579 15.9999C9.20813 15.9999 8.47754 15.2693 8.47754 14.3195V12.6392H10.1579Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1579 11.8353C9.20813 11.8353 8.47754 11.1048 8.47754 10.155C8.47754 9.2052 9.20813 8.47461 10.1579 8.47461H14.3954C15.3451 8.47461 16.0757 9.2052 16.0757 10.155C16.0757 11.1048 15.3451 11.8353 14.3954 11.8353H10.1579Z",
    fill: "#ECB22E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSlack);
export default __webpack_public_path__ + "static/media/sidebar_slack.664360d424673c3002fe135e31664d9b.svg";
export { ForwardRef as ReactComponent };